import React, { useRef } from 'react';
var VeltCommentsSidebarV2ListItem = function (props) {
    var annotation = props.annotation, scrollIdle = props.scrollIdle, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-list-item-v2", { ref: ref, annotation: annotation ? (typeof annotation === 'object' ? JSON.stringify(annotation) : annotation) : undefined, "scroll-idle": [true, false].includes(scrollIdle) ? (scrollIdle ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentsSidebarV2ListItem;
